import React from "react";

/**
 * This hook is used to disable changes to values in numeric 
 * fields when scrolling.
 */
export function useDisableWheelOnNumberInput() {
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    const input = inputRef.current;
    if (!input) return;

    const handleWheel = (e: WheelEvent) => {      
      e.preventDefault();
    };

    input.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      input.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return inputRef;
}